var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
var ASSET_PATH = process.env.ASSET_PATH;
export var cleanSrc = function (src) { return ASSET_PATH + src.replace(/^\//, ""); };
export default function Image(_a) {
    var _b = _a.src, src = _b === void 0 ? "" : _b, _c = _a.alt, alt = _c === void 0 ? "" : _c, fallbackSrc = _a.fallbackSrc, rest = __rest(_a, ["src", "alt", "fallbackSrc"]);
    var imgRef = React.useRef(null);
    return (React.createElement("img", __assign({ src: src.includes("http") ? src : cleanSrc(src), ref: imgRef, onError: function () {
            if (!fallbackSrc || !imgRef.current) {
                return;
            }
            // only run this once to avoid infinite loops
            imgRef.current.onerror = null;
            imgRef.current.src = cleanSrc(fallbackSrc);
        }, alt: alt }, rest)));
}
